export const partPriority = {
    metadata: {
        material_description: "2d",
        material_grade: "2d",
        material_density: "2d",
        part_type: "3d",
        shape_name: "3d",
        shape_nb: "3d",
        group: "3d",
        group_size: "3d",
        weight: "2d",
        weight_unit: "2d",
        distance_unit: "2d",
        other_info: "mixed",
        files: "mixed",
    },
    features: "3d",
    dimensions: {
        bbox: "3d",
        part: "3d",
    },
    complexity: {
        topo: "3d",
        roughnesses: "2d",
        gdts: "2d",
        measures: "2d",
    },
    representations: {
        graph: "3d",
        shape: "3d",
        embeddings: {
            topological: "3d",
        },
    },
};
